<template>
    <a-drawer :title="title" width="500" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="证书信息" bordered :column="1" size="middle">
            <a-descriptions-item label="证书名称">
                {{ item.name }}
            </a-descriptions-item>
            <a-descriptions-item label="证书编号">
                {{ item.sno }}
            </a-descriptions-item>
            <a-descriptions-item label="证书类型">
                <a-tag color="#f50">
                    {{ item.type | fmtCertType }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="证书级别">
                <a-tag color="#108ee9">
                    {{ item.grade | fmtCertGrade }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="证书等级">
                <a-tag color="#87d068">
                    {{ item.level }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="发证单位">
                {{ item.munit }}
            </a-descriptions-item>
            <a-descriptions-item label="联合单位">
                {{ item.eunit }}
            </a-descriptions-item>
            <a-descriptions-item label="有效期">
                <span>{{ item.indate }} 至 {{ item.expire }}</span>
            </a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <div class="ant-descriptions-title">证书图片</div>
        <a-row :gutter="[10, 10]">
            <a-col :span="6" v-for="img in images" :key="img">
                <div :style="{ width: '100px', height: '100px', border: '1px dashed grey', padding: '3px' }">
                    <img :src="img" :style="{ width: '100%', height: '100%' }" />
                </div>
            </a-col>
        </a-row>
        <a-divider />
        <a-descriptions title="证书状态" bordered :column="1" size="middle">
            <a-descriptions-item label="审核进度">
                <a-badge status="success" text="已通过" v-if="item.audit.state === 'Pass'" />
                <a-badge status="error" text="未通过" v-if="item.audit.state === 'Reject'" />
                <a-badge status="processing" text="审核中" v-if="item.audit.state === 'Wait'" />
                <a-badge status="warning" text="已过期" v-if="item.audit.state === 'Expire'" />
                <a-badge color="purple" text="已作废" v-if="item.audit.state === 'Cancel'" />
            </a-descriptions-item>
            <a-descriptions-item label="数据来源">
                {{ item.audit.dsrc }}
            </a-descriptions-item>
            <a-descriptions-item label="审核人员">
                {{ item.audit.aname }}
            </a-descriptions-item>
            <a-descriptions-item label="审核时间">
                {{ item.audit.atime }}
            </a-descriptions-item>
            <a-descriptions-item label="审核说明">
                {{ item.audit.amemo }}
            </a-descriptions-item>
        </a-descriptions>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        images() {
            return this.item.imgs.split(',')
        }
    }
}
</script>
